(function($) {  

  var mode  = $(window).innerWidth() >= 992 ? "PC" : "MOBILE";
  
    var component2    = $("#header");
    var state         = "BEFORE_SCROLL";
    var component     = $("#nav_wrap");
    var page          = $("#page");
    var body          = $("body");
    burger            = $('.header__nav-button');
    var blurZone      = $("<div class='nav-blur-zone'></div>");
    var isOpen        = false;
    var activeElement = null;




  //-------- Events Handlers --------


  

function openBurger(){
  $('.header__nav-button').addClass('header__nav-button_open');
}

// closeBurger

function closeBurger(){
  $('.header__nav-button').removeClass('header__nav-button_open');
}


function open(){
  if(isOpen == false)
  {
    isOpen = true;

    body.css("overflow", "hidden");
    openBurger();
    component.addClass("nav_open");
    blurZone.prependTo("#page");
  }
}

// close
function close(){
  if(isOpen == true)
  {
    isOpen = false;   
    body.css("overflow", "auto");
    closeBurger();
    component.removeClass("nav_open");
    blurZone.remove();
  }
}

// changeState

function changeState(){
  component2.css('transitionDuration', '0.4s');

  if(pageYOffset >= 30 && state === "BEFORE_SCROLL")
  {
    state = "AFTER_SCROLL";
    // console.log(pageYOffset);
    // console.log("scrolling", state);
    component2.addClass("is_sticky");
  }

  else if(pageYOffset < 30 && state === "AFTER_SCROLL")
  {
    state = "BEFORE_SCROLL";
    // console.log(pageYOffset);
    // console.log("not scrolling", state);
    component2.removeClass("is_sticky");
    
  }
}





// Scroll
$(window).on('scroll', function(){
  changeState();
});



$('body').on('click', '.nav-blur-zone', function(){
  close();
});


$('body').on('click', '.header__nav-button', function(e){
  if($(this).hasClass('header__nav-button_open')){
    close();
 }
 else {
  open();
  }
  //$('#nav_wrap').toggleClass('nav_open');
  //$('.header__nav-button').toggleClass('header__nav-button_open');
});



        // $('.home-product').owlCarousel({
        //     loop: true,
        //     nav: false,
        //     items:  1,
        //     dots: true,
     
        // });

  $(document).ready(function(){
  
  
        $('.home-product').slick({
  dots: false,
  infinite: true,
           autoplay: true,
  autoplaySpeed: 5000,
  speed: 300,
          arrows: true,
           
            prevArrow: "<a href='javascript:;' class='prev_Big'><span class='fa fa-angle-left'></span></a>",
            nextArrow: "<a href='javascript:;' class='next_Big'><span class='fa fa-angle-right'></span></a>",
  slidesToShow: 5,
           responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }

            ]
 
});
    
$('.testimonial-slider').slick({
  dots: false,
  infinite: true,
 
  slidesToShow: 1,
    autoplay: true,
  autoplaySpeed: 2000,
  adaptiveHeight: true
});
        

  
  $('.banner').slick({
    dots: false,
    infinite: true,
  slidesToShow: 1,
           arrows: true,
           
            prevArrow: "<a href='javascript:;' class='prev_Big'><span class='fa fa-angle-left'></span></a>",
            nextArrow: "<a href='javascript:;' class='next_Big'><span class='fa fa-angle-right'></span></a>",
 
  autoplay: true,
  autoplaySpeed: 5000,
});
	
});

    

     var navigation = new Navigation(document.getElementById("navigation"));


})(jQuery);

